/**
 * @desc        Firestore listeners for automation entities and tenant sensors.
 * @version     1.0.0 (Initial version) - 27 May 2026
 */

import { addEntitiesCollectionListener, addSensorsCollectionListener } from 'services/firebase/firebaseDb.js'
import * as actionTypes from '../action-types.js'

let entitiesListener = null
let sensorsListener = null

const toIdMap = items => {
    const map = {}
    ;(items ?? []).forEach(item => {
        if (item?.id != null) map[String(item.id)] = item
    })
    return map
}

export const subscribeAutomationFirestore = tenant => {
    return dispatch => {
        unsubscribeAutomationFirestore()

        if (!tenant || tenant === '*') return

        entitiesListener = addEntitiesCollectionListener(tenant, entities => {
            dispatch({
                type: actionTypes.FD_AUTOMATIONS_ENTITIES_SET,
                data: toIdMap(entities),
            })
        })

        sensorsListener = addSensorsCollectionListener(tenant, sensors => {
            dispatch({
                type: actionTypes.FD_AUTOMATIONS_SENSORS_SET,
                data: toIdMap(sensors),
            })
        })
    }
}

export const unsubscribeAutomationFirestore = () => {
    if (entitiesListener) {
        entitiesListener()
        entitiesListener = null
    }
    if (sensorsListener) {
        sensorsListener()
        sensorsListener = null
    }
}
